import ReactDOM from 'react-dom/client';
import { v2Component } from '../../..';
import { TenantContext } from '../../../context/tenant-context';
import { AddProduct } from './add-product';
import { Duration } from 'luxon';

export function initAddProduct() {
  document.getElementsByName('order-add-product').forEach((element) => {
    if (element.getAttribute('initalized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };

      const bootstrap = (mutations: MutationRecord[]) => {
        if (
          mutations.length === 0 ||
          mutations.find((r) => r.attributeName === 'data-location-id') ||
          mutations.find((r) => r.attributeName === 'data-is-cycle-billed') ||
          mutations.find((r) => r.attributeName === 'data-cycle-length')
        ) {
          const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
          const props = {
            ...dataset,
            isCycleBilled: dataset.isCycleBilled === '1',
            locationId: dataset.locationId ? parseInt(dataset.locationId) : undefined,
            cycleLength: dataset.cycleLength ? Duration.fromISO(dataset.cycleLength) : undefined,
          };

          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <AddProduct {...props} setRootAttributes={setRootAttributes} />
              </TenantContext.Provider>,
            ),
          );
          const event = new CustomEvent('change');
          element.dispatchEvent(event);
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
